import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../utils/translations';
import { SOCIAL_LINKS } from '../config/socialLinks';
import './SocialLinks.css';

function FacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M14.5 8.5V6.8c0-.7.5-1.3 1.3-1.3H17V3h-1.8C12.9 3 11 4.8 11 7.1v1.4H9v2.6h2V21h3.1v-9.9h2.3l.4-2.6h-2.7z"
      />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4c0 3.2-2.6 5.8-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8C2 4.6 4.6 2 7.8 2zm8.4 1.8H7.8c-2.2 0-4 1.8-4 4v8.4c0 2.2 1.8 4 4 4h8.4c2.2 0 4-1.8 4-4V7.8c0-2.2-1.8-4-4-4zM12 7.3A4.7 4.7 0 1 1 7.3 12 4.7 4.7 0 0 1 12 7.3zm0 1.8A2.9 2.9 0 1 0 14.9 12 2.9 2.9 0 0 0 12 9.1zm5.1-3.2a1.1 1.1 0 1 1-1.1 1.1 1.1 1.1 0 0 1 1.1-1.1z"
      />
    </svg>
  );
}

function XIcon() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M18.2 3H21l-6.6 7.5L22 21h-6.2l-4.4-5.7L6 21H3.2l7-8L2.2 3H8.6l4 5.2L18.2 3zm-1.1 16.2h1.7L7 4.7H5.2l11.9 14.5z"
      />
    </svg>
  );
}

const ICONS = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  twitter: XIcon
};

const SocialLinks = ({ variant = 'footer' }) => {
  const { language } = useLanguage();

  if (!SOCIAL_LINKS.length) return null;

  return (
    <div className={`social-links social-links--${variant}`}>
      <p className="social-links__label">{t(language, 'footer.followUs')}</p>
      <ul className="social-links__list">
        {SOCIAL_LINKS.map((item) => {
          const Icon = ICONS[item.id];
          const isLive = Boolean(item.href);
          const comingSoon = t(language, 'footer.socialComingSoon', { network: item.label });
          const content = (
            <>
              {Icon ? <Icon /> : null}
              <span className="social-links__name">{item.label}</span>
            </>
          );

          return (
            <li key={item.id}>
              {isLive ? (
                <a
                  href={item.href}
                  className="social-links__btn"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t(language, 'footer.openSocial', { network: item.label })}
                  title={item.label}
                >
                  {content}
                </a>
              ) : (
                <span
                  className="social-links__btn social-links__btn--soon"
                  aria-disabled="true"
                  aria-label={comingSoon}
                  title={comingSoon}
                >
                  {content}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SocialLinks;
